import { useState } from "react";
import { ZodError } from "zod";
import {
  QueueMessagesQueueValueType,
  QueueMessagesQueueItemType,
  QueueMessagesQueueLevelType,
} from "../types";

export function useQueueMessages() {
  const [messageItems, setMessageItems] = useState<
    QueueMessagesQueueItemType[]
  >([]);

  function addMessage<ComponentProps>(
    value: QueueMessagesQueueValueType<ComponentProps>,
    level: QueueMessagesQueueLevelType = "global",
  ) {
    const messageItem: QueueMessagesQueueItemType<ComponentProps> = {
      id: `key-${Math.random().toString(36).substring(2)}`,
      level: level,
      componentProps: {} as ComponentProps,
    };

    if (value instanceof Error || value instanceof ZodError) {
      console.error(value);
      messageItem.componentProps = {
        type: "error",
        message: !(value instanceof ZodError) ? value.message : null,
      } as ComponentProps;
    } else {
      messageItem.componentProps = {
        ...value,
      } as ComponentProps;
    }

    setMessageItems((messageItems) => [messageItem, ...messageItems]);
  }

  function removeMessage(id: QueueMessagesQueueItemType["id"]) {
    setMessageItems((messageItems) => [
      ...messageItems.filter(
        (message: QueueMessagesQueueItemType) => message.id !== id,
      ),
    ]);
  }

  return {
    addMessage,
    removeMessage,
    messageItems,
  };
}
